import { Injectable, inject } from '@angular/core';


import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom, map } from 'rxjs/operators';

import * as fromStore from '../store';
import * as fromRoot from '../../store';
import * as fromBlogs from '../../blogs/store';

import { Observable, of } from 'rxjs';
import { getSettings } from '../../settings/store';

@Injectable({ providedIn: 'root' })
export class ContentPageDetailGuard  {
  private store = inject<Store<fromStore.ContentState>>(Store);


  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getSelectedContentLoaded).pipe(
      withLatestFrom(this.store.select(fromRoot.getRouterState)),
      tap(([loaded, router]) => {
        if (!loaded) {
          const contentType: string = router.state.params['contentType'] || router.state.data['contentType'];
          const id: number = router.state.params['pageId'];
          switch (contentType.toLowerCase()) {
            case 'pagina':
              this.store.dispatch(fromStore.LoadContentPage({ id }));
              break;
            case 'evenementen':
              this.store.dispatch(fromStore.LoadEventDetail({ id }));
              break;
            case 'nieuws':
              this.store.dispatch(fromStore.LoadNewsDetail({ id }));
              break;
            case 'blogs':
              this.store.dispatch(fromBlogs.LoadBlogDetail({ id }));
              break;
          }
        }
      }),
      map(([loaded, router]) => loaded),
      filter(loaded => loaded!),
      take(1)
    );
  }
}
